var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-panel" },
    [
      _c(
        "div",
        {
          staticClass: "setting-panel-wrapper",
          class: { "close-setting-panel": !_vm.settingPanelShow },
        },
        [
          _c(
            "div",
            {
              staticClass: "setting-design-panel",
              style: { height: _vm.settingPanelShow ? "54.5px" : "48px" },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectItem._id && _vm.settingPanelShow,
                      expression: "selectItem._id && settingPanelShow",
                    },
                  ],
                  staticClass: "change-chart-type-menu",
                  on: { click: _vm.toggleChartTypeDropdown },
                },
                [
                  _c("div", { staticClass: "components-item" }, [
                    _c("div", { class: _vm.selectItem.className }),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.widgetConfig[_vm.selectItem.type] &&
                          _vm.widgetConfig[_vm.selectItem.type].name
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-caret-bottom",
                    class: { "is-expanded": _vm.isChartTypeDropdownOpen },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.isChartTypeDropdownOpen
                ? _c(
                    "div",
                    {
                      staticClass: "chart-type-dropdown-overlay",
                      on: { click: _vm.closeChartTypeDropdown },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "chart-type-dropdown-container",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "chart-type-widgets" },
                            _vm._l(
                              _vm.availableChartTypes,
                              function (chartType) {
                                return _c(
                                  "div",
                                  {
                                    key: chartType.type,
                                    staticClass: "chart-type-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeChartType(chartType)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "chart-type-icon" },
                                      [
                                        _c("div", {
                                          class: chartType.className,
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "chart-type-name" },
                                      [_vm._v(_vm._s(chartType.name))]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-s-unfold self-icon",
                on: { click: _vm.tabPanelCloseOrOpen },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.settingPanelShow
            ? [
                _c("c-tabs", {
                  attrs: { tabList: _vm.tabList },
                  on: { change: _vm.handleTabChange },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ui-schema-antd-tabs-content" },
                  [
                    _vm.activeTab === _vm.TAB_TYPES.FIELD
                      ? _c("field-tab", {
                          ref: "fieldTabRef",
                          attrs: {
                            getDwsData: _vm.getDwsData,
                            custom_updateData: _vm.custom_updateData,
                            fields: _vm.selectItem.fields || [],
                            selectItem: _vm.selectItem,
                          },
                          on: {
                            "on-update-single-chart":
                              _vm.handleUpdateSingleChart,
                            updateDashboard: _vm.updateDashboard,
                            updateFetchData: _vm.updateFetchData,
                          },
                        })
                      : _vm.activeTab === _vm.TAB_TYPES.STYLE
                      ? _c("style-tab", {
                          attrs: { "select-item": _vm.selectItem },
                          on: { styleUpdate: _vm.handleStyleUpdate },
                        })
                      : _vm.activeTab === _vm.TAB_TYPES.ADVANCED
                      ? _c("div", { staticClass: "tab-content" }, [
                          _c("p", [_vm._v("高级配置内容")]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "jzliu-bi-engine-setting-panel-vertical-text",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "jzliu-bi-engine-vertical-text",
                        on: {
                          click: function ($event) {
                            return _vm.handleHideTabChange(_vm.TAB_TYPES.FIELD)
                          },
                        },
                      },
                      [_vm._v("字段")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "jzliu-bi-engine-vertical-text",
                        on: {
                          click: function ($event) {
                            return _vm.handleHideTabChange(_vm.TAB_TYPES.STYLE)
                          },
                        },
                      },
                      [_vm._v("样式")]
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("data-panel", {
        attrs: { globalConfig: _vm.globalConfig, selectItem: _vm.selectItem },
        on: { "preview-detail": _vm.previewDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }